import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Modal, Popconfirm, Switch, Tooltip, Select } from 'antd';
import { CSVLink } from 'react-csv';
import DataTable from 'react-data-table-component';
import 'antd/dist/antd.css';
import { useHistory } from "react-router-dom";
import {
    ADMIN_GET_ALL_APPROVED_USERS,
    ADMIN_GET_ALL_APPROVED_EXPORT_USERS,
    POST_USER_CONTROL_STATUS,
    CHANGE_USER_STATUS,
    LEDGER_CORRECT_API,
    USER_ROLE,
    GET_SUPERIOR_ROLES,
    GET_USERS_BY_ROLE,
    UPDATE_USER_ROLE_PARENT,
    USER_BLOCK_UNBLOCK,
    USER_BLOCK_LOG,
    ADMIN_GET_REVERSIBLE_TXN,
    ADMIN_REVERSE_WALLET_TXN,
    USER_PERMISSION_BATCH
} from './../../../Utils/appConstants';
import { getRequest, postRequest } from './../../../Utils/AppApi';
import { ToastContainer, toast } from 'react-toastify';
import ImageViewer from 'react-simple-image-viewer';
import { hideCharters, getUser, kycStatusValue, INRFormat, isNumber } from './../../../Utils/Common';
import RequestMoney from '../../requestMoney';
import { getUTCToLocalDateFormat } from '../../../Utils/function';
import UserPermissionModal from '../../../container/UserPermissionModal';

const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * Full date + time formatter used in the reverse modal.
 */
const formatFullDateTime = (value) => {
    if (value === null || value === undefined || value === "") return "—";
    try {
        let d;
        if (value instanceof Date) {
            d = value;
        } else if (typeof value === "string") {
            d = new Date(value);
        } else if (typeof value === "number") {
            d = new Date(value);
        } else {
            return "—";
        }

        if (!d || isNaN(d.getTime())) return "—";

        const day = String(d.getDate()).padStart(2, "0");
        const month = MONTHS_SHORT[d.getMonth()];
        const year = d.getFullYear();
        const hh = String(d.getHours()).padStart(2, "0");
        const mm = String(d.getMinutes()).padStart(2, "0");
        const ss = String(d.getSeconds()).padStart(2, "0");

        return `${day}-${month}-${year} ${hh}:${mm}:${ss}`;
    } catch {
        return "—";
    }
};

function App(props) {
    const user = getUser();
    const history = useHistory();
    const csvLink = useRef();
    const limit = 10;

    const getMode = props.mode ? props.mode : "";
    const startDate = props.startDate ? props.startDate : "";
    const endDate = props.endDate ? props.endDate : "";
    const search = props.search ? props.search : "";

    const [getData, setData] = useState([]);
    const [getCsvData, setCsvData] = useState([]);
    const [getTotalRecord, setTotalRecord] = useState(0);
    const [isLimit, setLimit] = useState(limit);
    const [page, setPage] = useState(1);
    const [isModalUserDetail, setIsModalUserDetail] = useState(false);
    const [isModalUserApprovedReject, setIsModalUserApprovedReject] = useState(false);
    const [isSelectedUser, setIsSelectedUser] = useState([]);
    const [isSelectedUserAadharDetail, setIsSelectedUserAadharDetail] = useState({});
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [viewImage, setViewImage] = useState("");
    const [isReason, setIsReason] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [pancardNumber, setPancardNumber] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [aadharNumber, setAadharNumber] = useState("");

    const [isSuspendUser, setIsSuspendUser] = useState(false);
    const [isCreditUser, setIsCreditUser] = useState(false);
    const [isDebitUser, setIsDebitUser] = useState(false);

    const [isModalFundTopup, setIsModalFundTopup] = useState(false);
    const [requestMoneyUserId, setRequestMoneyUserId] = useState("");
    const [requestMoneyTitle, setRequestMoneyTitle] = useState("");

    const [capitalAmount, setCapitalAmount] = useState(0);

    // ---- Role & Parent management state ----
    const [isModalRoleParent, setIsModalRoleParent] = useState(false);
    const [selectedUserForRole, setSelectedUserForRole] = useState(null);
    const [allRoles, setAllRoles] = useState([]);
    const [newRoleId, setNewRoleId] = useState(null);
    const [parentRoleId, setParentRoleId] = useState(null);
    const [parentUserId, setParentUserId] = useState(null);
    const [parentRoleOptions, setParentRoleOptions] = useState([]);
    const [parentUserOptions, setParentUserOptions] = useState([]);
    const [roleParentLoading, setRoleParentLoading] = useState(false);

    // ---- User Permission modal state ----
    const [isModalUserPermission, setIsModalUserPermission] = useState(false);
    const [permissionUser, setPermissionUser] = useState(null);

    // ---- Block / Unblock modal state ----
    const [isModalBlockUnblock, setIsModalBlockUnblock] = useState(false);
    const [blockUnblockUser, setBlockUnblockUser] = useState(null);
    const [blockUnblockStatus, setBlockUnblockStatus] = useState(null);
    const [blockUnblockRemark, setBlockUnblockRemark] = useState("");
    const [blockUnblockSaving, setBlockUnblockSaving] = useState(false);

    // ---- Block log viewer state ----
    const [isModalBlockLog, setIsModalBlockLog] = useState(false);
    const [blockLogData, setBlockLogData] = useState([]);
    const [blockLogLoading, setBlockLogLoading] = useState(false);

    // ---- Reverse Wallet state ----
    const [isModalReverseWallet, setIsModalReverseWallet] = useState(false);
    const [reverseWalletUser, setReverseWalletUser] = useState(null);
    const [reverseWalletData, setReverseWalletData] = useState(null);
    const [reverseWalletLoading, setReverseWalletLoading] = useState(false);
    const [reverseWalletSubmitting, setReverseWalletSubmitting] = useState(false);
    const [reverseWalletAmount, setReverseWalletAmount] = useState("");
    const [reverseWalletRemark, setReverseWalletRemark] = useState("");

    // ---- Per-user permissions map (batch fetched) ----
    const [userPermissionsMap, setUserPermissionsMap] = useState({});

    let prpHide = {};
    if (props.roleOrderExist === 2) {
        prpHide = {
            name: 'Wallet',
            selector: row => row.walletbalances
                ? <Tooltip placement="bottom" title={INRFormat(row.walletbalances.balance)}>{INRFormat(row.walletbalances.balance)}</Tooltip>
                : 0,
        };
    }

    const columns = [
        {
            name: 'Actions',
            cell: row => {
                const showFundTopup =
                    user.data && user.data.role.code !== 'A' &&
                    userPermissionsMap[row.userId]?.fundTopup !== false;

                const showReverse =
                    user.data && user.data.role.code !== 'A' &&
                    user.data.role.code !== 'SH' &&
                    row.role?.code !== 'A' && row.role?.code !== 'SH';

                return (
                    <div className="d-flex align-items-center" style={{ gap: 8 }}>
                        {showFundTopup && (
                            <Tooltip title="Fund Topup">
                                <button
                                    type="button"
                                    className="action-icon-btn action-icon-green"
                                    onClick={(e) => handleFundTopup(e, row)}
                                    aria-label="Fund Topup"
                                >
                                    <i className="fa fa-rupee-sign"></i>
                                </button>
                            </Tooltip>
                        )}

                        <Tooltip title="View Details">
                            <button
                                type="button"
                                className="action-icon-btn action-icon-neutral"
                                onClick={(e) => handleUserDetail(e, row)}
                                aria-label="View Details"
                            >
                                <i className="fa fa-eye"></i>
                            </button>
                        </Tooltip>

                        <div className="action-divider" />

                        <Tooltip title="User Control">
                            <button
                                type="button"
                                className="action-icon-btn action-icon-red"
                                onClick={(e) => handleUserModel(e, row)}
                                aria-label="User Control"
                            >
                                <i className="fa fa-user-lock"></i>
                            </button>
                        </Tooltip>

                        {showReverse && (
                            <Tooltip title="Reverse Latest Transaction (30 min window)">
                                <button
                                    type="button"
                                    className="action-icon-btn action-icon-amber"
                                    onClick={(e) => handleOpenReverseModal(e, row)}
                                    aria-label="Reverse Transaction"
                                >
                                    <i className="fa fa-undo"></i>
                                </button>
                            </Tooltip>
                        )}
                    </div>
                );
            },
            omit: user.data.isStaff,
            width: "220px"
        },
        {
            name: 'User Id',
            selector: row => (
                <>
                    <Popconfirm
                        placement="left"
                        className='pointer'
                        title={"Are you sure want to Correct Wallet?"}
                        onConfirm={() => handleCorrect(row.user.username)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Tooltip placement="bottom" title={row.user.username}>{row.user.username}</Tooltip>
                    </Popconfirm>
                </>
            ),
            sortable: true,
            width: "120px"
        }, {
            name: 'User Type',
            selector: row => <Tooltip placement="bottom" title={row.role.name}>{row.user.isStaff ? "STAFF" : row.role.name}</Tooltip>,
            width: "120px",
        }, {
            name: 'Pan No.',
            selector: row => <Tooltip placement="bottom" title={hideCharters(row.pancardNumber)}>{hideCharters(row.pancardNumber)}</Tooltip>,
            width: "120px"
        }, {
            name: 'Name',
            selector: row => <Tooltip placement="bottom" title={row.user.name}>{row.user.name}</Tooltip>,
            width: "150px"
        }, {
            name: 'Mobile',
            selector: row => hideCharters(row.mobile),
            width: "120px"
        },

        // prpHide, 
        {
            name: 'Capital',
            selector: row => row.user.capitalAmount
                ? <Tooltip placement="bottom" title={INRFormat(row.user.capitalAmount)}>{INRFormat(row.user.capitalAmount)}</Tooltip>
                : 0,
        }, {
            name: 'Khata',
            selector: row => (row.khatabooks.length > 0)
                ? <Tooltip placement="bottom" title={INRFormat(row.khatabooks[0].closingBalance)}>{INRFormat(row.khatabooks[0].closingBalance)}</Tooltip>
                : 0,
        }, {
            name: 'Parent ID',
            selector: row => (
                <Tooltip placement="bottom" title={row.userParentDetail && row.userParentDetail.username}>
                    {row.userParentDetail && row.userParentDetail.username}
                </Tooltip>
            ),
            width: "150px"
        }, {
            name: 'KYC Status',
            cell: row => <>{kycStatusValue(row.user.KYCStatus)}</>,
        }, {
            name: 'Status',
            cell: row => (
                <>
                    {(row.user.status)
                        ? <div className="text-success">Active</div>
                        : <div className="text-danger">Blocked</div>
                    }
                </>
            ),
        }, {
            name: 'Referral Mobile Number',
            cell: row => <>{row.user.referralMobileNumber}</>,
        }, {
            name: 'Date',
            cell: row => getUTCToLocalDateFormat(row.createdAt),
            width: "120px"
        }
    ];

    // ================== BATCH PERMISSIONS ==================

    const fetchBatchPermissions = (userIds) => {
        if (!userIds || userIds.length === 0) return;
        postRequest(`${USER_PERMISSION_BATCH}`, { userIds }, history)
            .then((res) => {
                if (res.success === true && res.data) {
                    setUserPermissionsMap((prev) => ({ ...prev, ...res.data }));
                }
            })
            .catch(() => { });
    };

    // ================== HANDLERS ==================

    const handleCorrect = (username) => {
        try {
            if (username) {
                const payload = { username: username };
                postRequest(`${LEDGER_CORRECT_API}`, payload, history).then((response) => {
                    if (response.success === true) getDataReports();
                }).catch(() => { });
            }
        } catch (error) {
            console.log("error ---------------", error);
        }
    };

    const handleUserModel = (event, data) => {
        setIsModalUserApprovedReject(true);
        setIsSelectedUser(data);
        setIsSuspendUser(data.user.KYCStatus === 3 ? true : false);
        setIsCreditUser(data.user.creditStatus);
        setIsDebitUser(data.user.debitStatus);
        setIsReason(data.rejectReason);
        setCapitalAmount(data.user.capitalAmount);
    };

    const handleUserDetail = (event, data) => {
        setIsModalUserDetail(true);
        setIsSelectedUser(data);

        const userDetail = JSON.parse(JSON.stringify(data.aadharNumberVerifiedDetail));
        setIsSelectedUserAadharDetail(userDetail);

        setMobileNumber(hideCharters(data.mobile));
        setPancardNumber(hideCharters(data.pancardNumber));
        setAccountNumber(hideCharters(data.accountNumber));
        setAadharNumber(hideCharters(data.aadharNumber));
    };

    const handleFundTopup = (event, data) => {
        setIsModalFundTopup(true);
        setRequestMoneyTitle(data.user);
        setRequestMoneyUserId(data.userId);
    };

    // ---- User Permission handlers ----
    const handleOpenPermissionModal = (event, row) => {
        setPermissionUser({
            userId: row.userId,
            username: row.user?.username || '',
            name: row.user?.name || ''
        });
        setIsModalUserPermission(true);
    };

    const handleClosePermissionModal = () => {
        setIsModalUserPermission(false);
        setPermissionUser(null);
    };

    // ---- Reverse Wallet handlers ----
    const handleOpenReverseModal = (event, row) => {
        if (!row.role || row.role.code === 'A' || row.role.code === 'SH') {
            toast.error("Reverse is not available for Admin / SH accounts");
            return;
        }

        setReverseWalletUser({
            userId: row.userId,
            username: row.user?.username || '',
            name: row.user?.name || ''
        });
        setReverseWalletData(null);
        setReverseWalletAmount("");
        setReverseWalletRemark("");
        setIsModalReverseWallet(true);
        setReverseWalletLoading(true);

        getRequest(`${ADMIN_GET_REVERSIBLE_TXN}?userId=${row.userId}`, history)
            .then((res) => {
                if (res.success === true && res.data) {
                    setReverseWalletData(res.data);
                    setReverseWalletAmount(Number(res.data.maxReverseable).toFixed(2));
                } else {
                    toast.error(res.message || "No reversible transaction found");
                    setIsModalReverseWallet(false);
                    setReverseWalletUser(null);
                }
            })
            .catch(() => {
                toast.error("Failed to fetch reversible transaction");
                setIsModalReverseWallet(false);
                setReverseWalletUser(null);
            })
            .finally(() => setReverseWalletLoading(false));
    };

    const handleCloseReverseModal = () => {
        if (reverseWalletSubmitting) return;
        setIsModalReverseWallet(false);
        setReverseWalletUser(null);
        setReverseWalletData(null);
        setReverseWalletAmount("");
        setReverseWalletRemark("");
    };

    const handleSubmitReverse = () => {
        if (!reverseWalletUser || !reverseWalletData) return;

        const amount = parseFloat(reverseWalletAmount);
        if (isNaN(amount) || amount <= 0) {
            toast.error("Enter a valid amount");
            return;
        }
        if (amount < reverseWalletData.minReverseable) {
            toast.error(`Minimum is ₹${reverseWalletData.minReverseable}`);
            return;
        }
        if (amount > reverseWalletData.maxReverseable) {
            toast.error(`Maximum reverseable is ₹${Number(reverseWalletData.maxReverseable).toFixed(2)}`);
            return;
        }

        setReverseWalletSubmitting(true);

        const payload = {
            userId: reverseWalletUser.userId,
            ledgerId: reverseWalletData.ledgerId,
            amount: amount,
            remark: reverseWalletRemark.trim()
        };

        postRequest(`${ADMIN_REVERSE_WALLET_TXN}`, payload, history)
            .then((res) => {
                if (res.success === true) {
                    toast.success(res.message || "Reversed successfully");
                    setIsModalReverseWallet(false);
                    setReverseWalletUser(null);
                    setReverseWalletData(null);
                    setReverseWalletAmount("");
                    setReverseWalletRemark("");
                    getDataReports();
                } else {
                    toast.error(res.message || "Reversal failed");
                }
            })
            .catch(() => toast.error("Failed to reverse transaction"))
            .finally(() => setReverseWalletSubmitting(false));
    };

    // ---- Block / Unblock handlers ----
    const handleOpenBlockUnblock = (row, newStatus) => {
        setBlockUnblockUser({
            userId: row.userId,
            username: row.user?.username || '',
            name: row.user?.name || ''
        });
        setBlockUnblockStatus(newStatus);
        setBlockUnblockRemark("");
        setIsModalBlockUnblock(true);
    };

    const handleSubmitBlockUnblock = () => {
        if (!blockUnblockUser) return;
        if (!blockUnblockRemark || !blockUnblockRemark.trim()) {
            toast.error("Remark is required");
            return;
        }

        setBlockUnblockSaving(true);
        const payload = {
            userId: blockUnblockUser.userId,
            status: blockUnblockStatus,
            remark: blockUnblockRemark.trim()
        };

        postRequest(`${USER_BLOCK_UNBLOCK}`, payload, history).then((response) => {
            if (response.success === true) {
                toast.success(response.message);
                setIsModalBlockUnblock(false);
                setBlockUnblockUser(null);
                setBlockUnblockRemark("");
                getDataReports();
            } else {
                toast.error(response.message);
            }
        }).catch(() => {
            toast.error("Failed to update user status");
        }).finally(() => {
            setBlockUnblockSaving(false);
        });
    };

    const handleOpenBlockLog = (row) => {
        setBlockUnblockUser({
            userId: row.userId,
            username: row.user?.username || '',
            name: row.user?.name || ''
        });
        setBlockLogData([]);
        setIsModalBlockLog(true);
        setBlockLogLoading(true);

        getRequest(`${USER_BLOCK_LOG}?userId=${row.userId}&page=1&limit=50`, history)
            .then((response) => {
                if (response.success === true && response.data) {
                    setBlockLogData(response.data.docs || []);
                }
            })
            .catch(() => { })
            .finally(() => setBlockLogLoading(false));
    };

    // ---- Legacy change status (kept for any other caller) ----
    const handleChangeStatus = (userId, status) => {
        if (user.data.role.code === "A") {
            const payload = { userId: userId, status: status };
            postRequest(`${CHANGE_USER_STATUS}`, payload, history).then((response) => {
                if (response.success === true) {
                    getDataReports();
                    toast.success(response.message);
                } else {
                    toast.error(response.message);
                }
            }).catch(() => { });
        }
    };

    const onChangeSuspendUser = (checked) => setIsSuspendUser(checked);
    const onChangeCreditStatus = (checked) => setIsCreditUser(checked);
    const onChangeDebitStatus = (checked) => setIsDebitUser(checked);

    const handleCapitalAmount = (event) => {
        const { value } = event.target;
        setCapitalAmount(value);
    };

    const handleSave = (data) => {
        const payload = {
            userId: data.userId,
            status: isSuspendUser,
            creditStatus: isCreditUser,
            debitStatus: isDebitUser,
            reason: isReason,
            capitalAmount: capitalAmount
        };
        handleSubmit(payload);
    };

    const handleSubmit = (data) => {
        postRequest(`${POST_USER_CONTROL_STATUS}`, data, history).then((response) => {
            if (response.success === true) {
                toast.success(response.message);
                getDataReports();
                handleHideModal();
            } else {
                toast.error(response.message);
            }
        }).catch(() => {
            handleHideModal();
        });
    };

    const handleHideModal = () => {
        setIsModalFundTopup(false);
        setIsModalUserDetail(false);
        setIsModalUserApprovedReject(false);
    };

    const objectToQueryString = (obj) => {
        const str = [];
        for (const p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    };

    const params = { page: page, limit: isLimit };

    const getDataReports = (data) => {
        if (data) {
            setLimit(data);
            params.limit = data;
        }
        if (startDate && endDate) {
            params.startDate = startDate ? startDate : "";
            params.endDate = endDate ? endDate : "";
        }

        params.roleId = getMode;

        if (search) {
            params.search = search ? search : "";
        }

        const queryString = objectToQueryString(params);
        getRequest(`${ADMIN_GET_ALL_APPROVED_USERS}?${queryString}`, history).then((response) => {
            if (response.success === true) {
                setData(response.data);
                setTotalRecord(response.data.totalDocs);
                setPage(response.data.page);

                // Batch fetch permissions for visible users
                const userIds = (response.data.docs || []).map((d) => d.userId).filter(Boolean);
                fetchBatchPermissions(userIds);
            } else {
                setData([]);
                setTotalRecord(0);
                setPage(1);
            }
        }).catch((error) => {
            console.log(error);
        });
    }; // eslint-disable-line react-hooks/exhaustive-deps

    const getCSVDataList = () => {
        const csvParams = {};
        if (startDate && endDate) {
            csvParams.startDate = startDate ? startDate : "";
            csvParams.endDate = endDate ? endDate : "";
        }

        const queryString = objectToQueryString(csvParams);
        getRequest(`${ADMIN_GET_ALL_APPROVED_EXPORT_USERS}?${queryString}`, history).then(async (response) => {
            if (response.success === true) {
                const csvdataRecord = [];
                const csvdata = response.data;
                await csvdata.map((e) => {
                    return csvdataRecord.push({
                        "User Id": e.user.username,
                        "User Type": e.user.isStaff ? "STAFF" : e.role.name,
                        "Pan No.": e.pancardNumber,
                        "Reff User": e.refmobile,
                        "Name": e.user.name,
                        "Mobile": e.mobile,
                        "Capital": INRFormat(e.user.capitalAmount),
                        "Wallet Balance": INRFormat(e.walletbalances.balance),
                        "Khata": INRFormat(e.khatabooks.length > 0 ? e.khatabooks[0].closingBalance : 0),
                        "Parent ID": e.userParentDetail && e.userParentDetail.username,
                        "KYC Status": kycStatusValue(e.user.KYCStatus),
                        "Status": (e.user.status ? "Active" : "Deactive"),
                        "Date": getUTCToLocalDateFormat(e.createdAt)
                    });
                });
                setCsvData(csvdataRecord);
                setTimeout(() => {
                    csvLink.current.link.click();
                }, 1000);
            } else {
                setCsvData([]);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    const handlePageChange = page => setPage(page);

    useEffect(() => {
        getDataReports();
    }, [page, props.handleSearch]); // eslint-disable-line react-hooks/exhaustive-deps

    // Load full role list once (for Role dropdown)
    useEffect(() => {
        getRequest(USER_ROLE, history).then((response) => {
            if (response.success === true) {
                setAllRoles(response.data || []);
            }
        }).catch(() => { });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const openImageViewer = useCallback((image) => {
        setViewImage(image);
        setIsModalUserDetail(false);
        setIsViewerOpen(true);
    }, []);

    const closeImageViewer = () => {
        setViewImage("");
        setIsModalUserDetail(true);
        setIsViewerOpen(false);
    };

    const handleMouseOver = (originalString, field) => {
        if (field === "mobile") setMobileNumber(originalString);
        else if (field === "pancardNumber") setPancardNumber(originalString);
        else if (field === "accountNumber") setAccountNumber(originalString);
        else if (field === "aadharNumber") setAadharNumber(originalString);
    };

    const handleMouseOut = (originalString, field) => {
        if (field === "mobile") setMobileNumber(hideCharters(originalString));
        else if (field === "pancardNumber") setPancardNumber(hideCharters(originalString));
        else if (field === "accountNumber") setAccountNumber(hideCharters(originalString));
        else if (field === "aadharNumber") setAadharNumber(hideCharters(originalString));
    };

    // ================== ROLE & PARENT HANDLERS ==================

    const loadParentRoles = async (roleId) => {
        if (!roleId) {
            setParentRoleOptions([]);
            return;
        }
        setRoleParentLoading(true);
        try {
            const res = await getRequest(`${GET_SUPERIOR_ROLES}/${roleId}`, history);
            if (res.success) {
                setParentRoleOptions(res.data || []);
            } else {
                setParentRoleOptions([]);
            }
        } catch (err) {
            setParentRoleOptions([]);
        } finally {
            setRoleParentLoading(false);
        }
    };

    const loadParentUsers = async (roleId, excludeUserId) => {
        if (!roleId) {
            setParentUserOptions([]);
            return;
        }
        setRoleParentLoading(true);
        try {
            const res = await getRequest(
                `${GET_USERS_BY_ROLE}?roleId=${roleId}&excludeUserId=${excludeUserId || ''}`,
                history
            );
            if (res.success) {
                setParentUserOptions(res.data || []);
            } else {
                setParentUserOptions([]);
            }
        } catch (err) {
            setParentUserOptions([]);
        } finally {
            setRoleParentLoading(false);
        }
    };

    const handleOpenRoleParentModal = async (event, row) => {
        setSelectedUserForRole(row);
        setIsModalRoleParent(true);

        const currentRoleId = row.user?.roleId || row.roleObjectId;
        const currentParentId = row.user?.createdBy || null;

        setNewRoleId(currentRoleId);
        setParentUserId(currentParentId || null);
        setParentRoleId(null);
        setParentUserOptions([]);

        await loadParentRoles(currentRoleId);

        if (currentParentId && row.userParentDetail) {
            setParentRoleId(row.userParentDetail.roleId);
            await loadParentUsers(row.userParentDetail.roleId, row.userId);
            setParentUserId(currentParentId);
        }
    };

    const handleRoleChange = async (value) => {
        setNewRoleId(value);
        setParentRoleId(null);
        setParentUserId(null);
        setParentUserOptions([]);
        await loadParentRoles(value);
    };

    const handleParentRoleChange = async (value) => {
        setParentRoleId(value);
        setParentUserId(null);
        await loadParentUsers(value, selectedUserForRole?.userId);
    };

    const handleSaveRoleParent = async () => {
        if (!newRoleId) return toast.error("Please select a role");
        if (!parentRoleId) return toast.error("Please select a parent role");
        if (!parentUserId) return toast.error("Please select a parent user");

        const currentOrder = getCurrentRoleOrder();
        const newRole = allRoles.find(r => r._id === newRoleId);
        if (currentOrder != null && newRole && Number(newRole.order) > currentOrder) {
            return toast.error("Cannot downgrade to a less-senior role");
        }

        if (!parentRoleOptions.length) {
            return toast.error("No eligible parent role available for this role");
        }

        const payload = {
            userId: selectedUserForRole.userId,
            roleId: newRoleId,
            parentId: parentUserId
        };

        postRequest(UPDATE_USER_ROLE_PARENT, payload, history).then((response) => {
            if (response.success) {
                toast.success(response.message || "Updated successfully");
                setIsModalRoleParent(false);
                getDataReports();
            } else {
                toast.error(response.message || "Update failed");
            }
        });
    };

    const getPreviewFlags = () => {
        if (!newRoleId) return [];
        const r = allRoles.find(x => x._id === newRoleId);
        if (!r) return [];
        const code = String(r.code || '').toUpperCase();
        const flags = [];
        if (code === 'S') flags.push('STAFF');
        if (code === 'M') flags.push('MEMBER');
        return flags;
    };

    const getCurrentRoleOrder = () => {
        if (!selectedUserForRole || !allRoles.length) return null;

        const currentId = selectedUserForRole.roleObjectId || selectedUserForRole.user?.roleId;
        const currentCode = selectedUserForRole.role?.code;

        const matched =
            allRoles.find(r => String(r._id) === String(currentId)) ||
            allRoles.find(r => String(r.code) === String(currentCode));

        return matched ? Number(matched.order) : null;
    };

    const getEligibleNewRoles = () => {
        const currentOrder = getCurrentRoleOrder();
        if (currentOrder == null) return allRoles;
        return allRoles.filter(r => Number(r.order) <= currentOrder);
    };

    return (
        <div>
            <style>{`
                .action-icon-btn {
                    width: 32px;
                    height: 32px;
                    border-radius: 8px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    border: none;
                    cursor: pointer;
                    font-size: 13px;
                    padding: 0;
                    transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
                }

                .action-icon-btn:focus {
                    outline: none;
                    box-shadow: 0 0 0 2px rgba(201, 38, 44, 0.25);
                }

                .action-icon-btn:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
                }

                .action-icon-btn:active {
                    transform: translateY(0);
                    box-shadow: none;
                }

                .action-icon-neutral {
                    background: #F3F4F6;
                    color: #4B5563;
                }
                .action-icon-neutral:hover {
                    background: #E5E7EB;
                    color: #1F2937;
                }

                .action-icon-green {
                    background: #ECFDF5;
                    color: #059669;
                }
                .action-icon-green:hover {
                    background: #D1FAE5;
                    color: #047857;
                }

                .action-icon-amber {
                    background: #FFFBEB;
                    color: #D97706;
                }
                .action-icon-amber:hover {
                    background: #FEF3C7;
                    color: #B45309;
                }

                .action-icon-red {
                    background: #FEF2F2;
                    color: #DC2626;
                }
                .action-icon-red:hover {
                    background: #FEE2E2;
                    color: #B91C1C;
                }

                .action-divider {
                    width: 1px;
                    height: 18px;
                    background: #E5E7EB;
                    margin: 0 2px;
                    align-self: center;
                    flex-shrink: 0;
                }
            `}</style>

            <div className="container-fluid pt-2 pb-5">
                <div className="col-md-12">
                    {user.data.role.code === "A" &&
                        <div className='float-sm-right d-flex mb-1'>
                            <button
                                type="button"
                                className="btn btn-primary mr-3"
                                onClick={() => getCSVDataList()}
                            >
                                <i className="fa fa-file-excel"></i> Export
                            </button>
                            <CSVLink
                                data={getCsvData}
                                filename='manage-user-report.csv'
                                className='hidden'
                                ref={csvLink}
                                target='_blank'
                            />
                        </div>}
                    <div className="box-body">
                        <DataTable
                            columns={columns}
                            data={getData.docs}
                            highlightOnHover
                            pagination
                            paginationServer
                            striped
                            paginationTotalRows={getTotalRecord}
                            onChangeRowsPerPage={getDataReports}
                            onChangePage={handlePageChange}
                        />
                    </div>
                </div>
            </div>

            <ToastContainer
                position="top-center"
                autoClose={5000}
                limit={2}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />

            {isViewerOpen && (
                <ImageViewer
                    src={[viewImage]}
                    currentIndex={0}
                    disableScroll={false}
                    closeOnClickOutside={true}
                    onClose={closeImageViewer}
                />
            )}

            {/* --------- User Control Modal --------- */}
            {isModalUserApprovedReject &&
                <Modal
                    title={"User Management"}
                    width={600}
                    open={isModalUserApprovedReject}
                    onOk={() => handleSave(isSelectedUser)}
                    onCancel={handleHideModal}
                    okText={"Save"}
                    cancelText={"Cancel"}
                >
                    <div className='row'>
                        <div className='col-md-12 d-flex'>
                            {user.data.role.code === "A" &&
                                <>
                                    <div className="form-group col-md-4">
                                        <label>Re KYC Doc: </label>{' '}
                                        <Switch size="small" defaultChecked={isSuspendUser} onChange={onChangeSuspendUser} /> {isSuspendUser}
                                    </div>
                                    <div className="form-group col-md-4">
                                        <label>Debit Freeze: </label>{' '}
                                        <Switch
                                            size="small"
                                            defaultChecked={isDebitUser}
                                            style={{ backgroundColor: isDebitUser ? 'green' : 'red' }}
                                            onChange={onChangeDebitStatus}
                                        />
                                    </div>
                                </>}
                            {user.data.role.code !== "A" &&
                                <div className="form-group col-md-4">
                                    <label>Credit Freeze: </label>{' '}
                                    <Switch
                                        size="small"
                                        defaultChecked={isCreditUser}
                                        style={{ backgroundColor: isCreditUser ? 'green' : 'red' }}
                                        onChange={onChangeCreditStatus}
                                    />
                                </div>}
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12 form-group'>
                            <label>Reason: </label>
                            <textarea className="form-group form-control" cols={"4"} rows={"5"}>{isReason}</textarea>
                        </div>
                        <div className='col-md-12 form-group'>
                            <label>Capital Amount: </label>
                            <input
                                type='text'
                                name="capital_amount"
                                className="form-group form-control"
                                value={capitalAmount}
                                onChange={(e) => handleCapitalAmount(e)}
                                onKeyDown={isNumber}
                                maxLength={6}
                            />
                        </div>
                    </div>
                </Modal>}

            {/* --------- Reverse Wallet Modal --------- */}
            {isModalReverseWallet && reverseWalletUser &&
                <Modal
                    title={
                        <span>
                            <i className="fa fa-undo mr-2 text-warning" />
                            Reverse Latest Transaction — {reverseWalletUser.name} ({reverseWalletUser.username})
                        </span>
                    }
                    width={560}
                    open={isModalReverseWallet}
                    onOk={handleSubmitReverse}
                    onCancel={handleCloseReverseModal}
                    okText="Reverse Wallet"
                    cancelText="Cancel"
                    confirmLoading={reverseWalletSubmitting}
                    okButtonProps={{
                        disabled: reverseWalletLoading || !reverseWalletData,
                        style: {
                            background: '#F59E0B',
                            borderColor: '#F59E0B',
                            fontWeight: 600
                        }
                    }}
                >
                    {reverseWalletLoading ? (
                        <div className="text-center py-4">Loading reversible transaction…</div>
                    ) : reverseWalletData ? (
                        <>
                            <div style={{
                                background: '#FFFBEB',
                                border: '1px solid #FCD34D',
                                borderRadius: 8,
                                padding: '12px 14px',
                                marginBottom: 16
                            }}>
                                <div className="row">
                                    <div className="col-md-6 mb-2">
                                        <div style={{ fontSize: 11, color: '#92400E', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                                            Original Transaction
                                        </div>
                                        <div style={{ fontSize: 13, color: '#1A1A2E', fontWeight: 600, marginTop: 2 }}>
                                            {reverseWalletData.transactionId}
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <div style={{ fontSize: 11, color: '#92400E', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                                            Original Amount
                                        </div>
                                        <div style={{ fontSize: 13, color: '#1A1A2E', fontWeight: 600, marginTop: 2 }}>
                                            {INRFormat(reverseWalletData.originalAmount)}
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <div style={{ fontSize: 11, color: '#92400E', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                                            Service
                                        </div>
                                        <div style={{ fontSize: 13, color: '#1A1A2E', marginTop: 2 }}>
                                            {reverseWalletData.serviceName || '—'}
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <div style={{ fontSize: 11, color: '#92400E', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                                            Transaction Time
                                        </div>
                                        <div style={{ fontSize: 13, color: '#1A1A2E', marginTop: 2 }}>
                                            {formatFullDateTime(reverseWalletData.txnDate)}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12 mb-2">
                                    <small className="text-muted">
                                        Current wallet balance: <b>{INRFormat(reverseWalletData.walletBalance)}</b>
                                        {' · '}
                                        Max reverseable: <b>{INRFormat(reverseWalletData.maxReverseable)}</b>
                                    </small>
                                </div>

                                <div className="col-md-12 form-group">
                                    <label>
                                        Reverse Amount (₹) <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type='number'
                                        className="form-control"
                                        placeholder={`Between ₹${reverseWalletData.minReverseable} and ₹${Number(reverseWalletData.maxReverseable).toFixed(2)}`}
                                        value={reverseWalletAmount}
                                        onChange={(e) => setReverseWalletAmount(e.target.value)}
                                        min={reverseWalletData.minReverseable}
                                        max={reverseWalletData.maxReverseable}
                                        step="0.01"
                                        style={{ borderRadius: 8, fontSize: 15 }}
                                    />
                                    <small className="text-muted">
                                        Minimum ₹{reverseWalletData.minReverseable} · Maximum ₹{Number(reverseWalletData.maxReverseable).toFixed(2)}
                                    </small>
                                </div>

                                <div className="col-md-12 form-group">
                                    <label>Remark (optional)</label>
                                    <textarea
                                        className="form-control"
                                        rows={3}
                                        placeholder="Reason for reversal (optional, for audit)"
                                        value={reverseWalletRemark}
                                        onChange={(e) => setReverseWalletRemark(e.target.value)}
                                        style={{ borderRadius: 8, resize: 'none' }}
                                    />
                                    <small className="text-muted">
                                        This will be stored with the reversal for audit purposes.
                                    </small>
                                </div>
                            </div>

                            <div style={{
                                fontSize: 11,
                                color: '#92400E',
                                background: '#FEF3C7',
                                borderRadius: 6,
                                padding: '8px 12px'
                            }}>
                                <i className="fa fa-exclamation-triangle mr-1"></i>
                                Reversing will debit this user's wallet and credit the parent's wallet. This action cannot be undone.
                            </div>
                        </>
                    ) : null}
                </Modal>}

            {/* --------- Fund Topup Modal --------- */}
            {/* --------- Fund Topup Modal --------- */}
            {isModalFundTopup &&
                <Modal
                    title={"Fund Topup"}
                    width={1200}
                    open={isModalFundTopup}
                    onCancel={handleHideModal}
                    footer={false}
                    destroyOnClose
                >
                    <RequestMoney
                        userData={requestMoneyTitle}
                        requestMoneyUserId={requestMoneyUserId}
                        isRequestMoney={true}
                        onCancel={handleHideModal}
                    />
                </Modal>}

            {/* --------- User Detail Modal --------- */}
            {isModalUserDetail &&
                <Modal
                    title={isSelectedUser.user.name}
                    width={500}
                    open={isModalUserDetail}
                    onCancel={handleHideModal}
                    footer={false}
                >
                    {isSelectedUser ?
                        <ul>
                            <li><span>Name</span> : {isSelectedUser.user.name}</li>
                            <li><span>Role Name</span> : {isSelectedUser.role.name}</li>
                            <li><span>Father Name</span> : {isSelectedUser.fatherName}</li>
                            <li><span>Mother Name</span> : {isSelectedUser.motherName}</li>
                            <li><span>Mobile Number</span> : <span onMouseOver={() => handleMouseOver(isSelectedUser.mobile, "mobile")} onMouseOut={() => handleMouseOut(isSelectedUser.mobile, "mobile")}>{mobileNumber}</span></li>
                            <li><span>Email</span> : {isSelectedUser.email}</li>
                            <li><span>Email Verify</span> : {isSelectedUser.emailVerify}</li>
                            <li><span>Phone Number</span> : {isSelectedUser.phone}</li>
                            <li><span>Pincode</span> : {isSelectedUser.pincode}</li>
                            <li><span>City Name</span> : {isSelectedUser.city}</li>
                            <li><span>State Name</span> : {isSelectedUser.stateObjectId && isSelectedUser.state[0].name}</li>
                            <li><span>Outlet Name</span> : {isSelectedUser.outletName}</li>
                            <li><span>Account Number</span> : <span onMouseOver={() => handleMouseOver(isSelectedUser.accountNumber, "accountNumber")} onMouseOut={() => handleMouseOut(isSelectedUser.accountNumber, "accountNumber")}>{accountNumber}</span></li>
                            <li><span>IFSC Code</span> : {isSelectedUser.ifscCode}</li>
                            <li><span>Bank Name</span> : {isSelectedUser.bankName}</li>
                            <li><span>Account Holder Name</span> : {isSelectedUser.accountHolderName}</li>
                            <li><span>Bank Proof</span> : <div className='text-right'><span className='pointer' onClick={() => openImageViewer(isSelectedUser.bankProof)}><u>Show Image</u></span></div></li>
                            <li><span>Pancard Number</span> : <span onMouseOver={() => handleMouseOver(isSelectedUser.pancardNumber, "pancardNumber")} onMouseOut={() => handleMouseOut(isSelectedUser.pancardNumber, "pancardNumber")}>{pancardNumber}</span></li>
                            <li><span>Pancard Number Verify</span> : {isSelectedUser.pancardNumberVerify ? "Yes" : "No"}</li>
                            <li><span>Pan Card Photo</span> : <div className='text-right'><span className='pointer' onClick={() => openImageViewer(isSelectedUser.panCardPhoto)}><u>Show Image</u></span></div></li>
                            <li><span>Aadhar Number</span> : <span onMouseOver={() => handleMouseOver(isSelectedUser.aadharNumber, "aadharNumber")} onMouseOut={() => handleMouseOut(isSelectedUser.aadharNumber, "aadharNumber")}>{aadharNumber}</span></li>
                            <li><span>Aadhar Number Verify</span> : {isSelectedUser.aadharNumberVerify ? "Yes" : "No"}</li>
                            <li><span>Aadhar Name</span> : {isSelectedUserAadharDetail && isSelectedUserAadharDetail.name}</li>
                            <li><span>Address</span> : {isSelectedUserAadharDetail && isSelectedUserAadharDetail.address}</li>
                            <li><span>Date Of Birth</span> : {isSelectedUserAadharDetail && isSelectedUserAadharDetail.dob}</li>
                            <li><span>Aadhar Profile Photo</span> : {isSelectedUserAadharDetail && isSelectedUserAadharDetail.photo_link && <div className='text-right'><img className="elevation-2" src={"data:image/png;base64," + isSelectedUserAadharDetail.photo_link} alt="User Avatar" /></div>}</li>
                            <li><span>Aadhar Card Photo</span> : <div className='text-right'><span className='pointer' onClick={() => openImageViewer(isSelectedUser.aadharPhoto)}><u>Show Image</u></span></div></li>
                            <li><span>GST In Number</span> : {isSelectedUser.gstInNumber}</li>
                            <li><span>GST In Number Verify</span> : {isSelectedUser.gstInNumberVerify ? "Yes" : "No"}</li>
                            <li><span>GST In Photo</span> : <div className='text-right'><span className='pointer' onClick={() => openImageViewer(isSelectedUser.gstInPhoto)}><u>Show Image</u></span></div></li>
                            <li><span>Selfie Photo</span> : <div className='text-right'><span className='pointer' onClick={() => openImageViewer(isSelectedUser.selfiePhoto)}><u>Show Image</u></span></div></li>
                            <li><span>Communication Address</span> : {isSelectedUser.communicationAddress}</li>
                            <li><span>Registered Address</span> : {isSelectedUser.registeredAddress}</li>
                            <li><span>Business Address</span> : {isSelectedUser.businessAddress}</li>
                        </ul>
                        : ""}
                </Modal>}

            {/* --------- Block / Unblock Modal --------- */}
            {isModalBlockUnblock && blockUnblockUser &&
                <Modal
                    title={
                        <span>
                            <i className={`fa ${blockUnblockStatus ? 'fa-unlock' : 'fa-lock'} mr-2`} />
                            {blockUnblockStatus ? 'Unblock User' : 'Block User'}
                            {' — '}{blockUnblockUser.name} ({blockUnblockUser.username})
                        </span>
                    }
                    width={520}
                    open={isModalBlockUnblock}
                    onOk={handleSubmitBlockUnblock}
                    onCancel={() => {
                        setIsModalBlockUnblock(false);
                        setBlockUnblockUser(null);
                        setBlockUnblockRemark("");
                    }}
                    okText={blockUnblockStatus ? 'Unblock' : 'Block'}
                    cancelText="Cancel"
                    confirmLoading={blockUnblockSaving}
                    okButtonProps={{
                        style: {
                            background: blockUnblockStatus ? '#02A650' : '#C9262C',
                            borderColor: blockUnblockStatus ? '#02A650' : '#C9262C',
                            fontWeight: 600
                        }
                    }}
                >
                    <div className='row'>
                        <div className='col-md-12 mb-2'>
                            <small className='text-muted'>
                                Current status: <b>{blockUnblockStatus ? 'Deactive' : 'Active'}</b>
                                {' → '}
                                Will become: <b>{blockUnblockStatus ? 'Active' : 'Deactive'}</b>
                            </small>
                        </div>
                        <div className='col-md-12 form-group'>
                            <label>Remark <span className='text-danger'>*</span></label>
                            <textarea
                                className='form-control'
                                rows={3}
                                placeholder='Reason for this action (required)'
                                value={blockUnblockRemark}
                                onChange={(e) => setBlockUnblockRemark(e.target.value)}
                                style={{ borderRadius: 8, resize: 'none' }}
                            />
                            <small className='text-muted'>
                                This remark will be stored with the action and visible in the log.
                            </small>
                        </div>
                    </div>
                </Modal>}

            {/* --------- Block / Unblock Log Modal --------- */}
            {isModalBlockLog && blockUnblockUser &&
                <Modal
                    title={
                        <span>
                            <i className="fa fa-history mr-2 text-info" />
                            Block / Unblock Log — {blockUnblockUser.name} ({blockUnblockUser.username})
                        </span>
                    }
                    width={720}
                    open={isModalBlockLog}
                    onCancel={() => {
                        setIsModalBlockLog(false);
                        setBlockUnblockUser(null);
                        setBlockLogData([]);
                    }}
                    footer={[
                        <button
                            key="close"
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => {
                                setIsModalBlockLog(false);
                                setBlockUnblockUser(null);
                                setBlockLogData([]);
                            }}
                        >
                            Close
                        </button>
                    ]}
                >
                    {blockLogLoading ? (
                        <div className='text-center py-4'>Loading…</div>
                    ) : blockLogData.length === 0 ? (
                        <div className='text-center text-muted py-4'>No log entries found.</div>
                    ) : (
                        <div style={{ maxHeight: 480, overflowY: 'auto' }}>
                            <table className='table table-sm table-bordered'>
                                <thead>
                                    <tr>
                                        <th style={{ width: 60 }}>#</th>
                                        <th style={{ width: 110 }}>Action</th>
                                        <th style={{ width: 150 }}>Date</th>
                                        <th style={{ width: 150 }}>By</th>
                                        <th>Remark</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {blockLogData.map((log, i) => (
                                        <tr key={log._id || i}>
                                            <td>{i + 1}</td>
                                            <td>
                                                {log.action === 'block'
                                                    ? <span className='badge badge-danger'>Blocked</span>
                                                    : <span className='badge badge-success'>Unblocked</span>}
                                            </td>
                                            <td>{getUTCToLocalDateFormat(log.createdAt)}</td>
                                            <td>{log.actionByName || '—'}</td>
                                            <td>{log.remark}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </Modal>}

            {/* --------- Change Role & Parent Modal --------- */}
            {isModalRoleParent && selectedUserForRole &&
                <Modal
                    title={`Change Role & Parent — ${selectedUserForRole.user?.name || ''}`}
                    width={620}
                    open={isModalRoleParent}
                    onOk={handleSaveRoleParent}
                    onCancel={() => setIsModalRoleParent(false)}
                    okText="Save"
                    cancelText="Cancel"
                    confirmLoading={roleParentLoading}
                    okButtonProps={{
                        disabled:
                            !newRoleId ||
                            !parentRoleId ||
                            !parentUserId ||
                            roleParentLoading
                    }}
                >
                    <div className='row'>
                        <div className='col-md-12 mb-2'>
                            <small className='text-muted'>
                                Current Role: <b>{selectedUserForRole.role?.name}</b> &nbsp;|&nbsp;
                                Current Parent: <b>{selectedUserForRole.userParentDetail?.username || '—'}</b>
                            </small>
                        </div>

                        <div className='col-md-12 mb-2'>
                            <small className='text-muted'>
                                Flags now:&nbsp;
                                {selectedUserForRole.user?.isStaff && <span className='badge badge-primary mr-1'>STAFF</span>}
                                {selectedUserForRole.user?.isMember && <span className='badge badge-info mr-1'>MEMBER</span>}
                                {selectedUserForRole.user?.isEmployee && <span className='badge badge-warning mr-1'>EMPLOYEE</span>}
                                {!selectedUserForRole.user?.isStaff &&
                                    !selectedUserForRole.user?.isMember &&
                                    !selectedUserForRole.user?.isEmployee && <span className='text-secondary'>none</span>}
                            </small>
                        </div>

                        <div className='col-md-12 form-group'>
                            <label>
                                New Role <span className='text-danger'>*</span>
                                <small className='text-muted ml-2'>
                                    (same or more senior than current — no downgrade)
                                </small>
                            </label>
                            <Select
                                className='w-100'
                                placeholder="Select New Role"
                                value={newRoleId || undefined}
                                onChange={handleRoleChange}
                                showSearch
                                optionFilterProp="label"
                                options={getEligibleNewRoles().map(r => ({
                                    value: r._id,
                                    label: `${r.name} (${r.code})`
                                }))}
                            />
                        </div>

                        {newRoleId && (
                            <div className='col-md-12 mb-2'>
                                <small className='text-info'>
                                    After save:&nbsp;
                                    {(() => {
                                        const flags = getPreviewFlags();
                                        return flags.length
                                            ? flags.map(f => <span key={f} className='badge badge-success mr-1'>{f}</span>)
                                            : <span className='text-secondary'>no special flags (regular user)</span>;
                                    })()}
                                </small>
                            </div>
                        )}

                        <div className='col-md-12 form-group'>
                            <label>
                                Parent Role <span className='text-danger'>*</span>
                                <small className='text-muted ml-2'>(must be senior to New Role)</small>
                            </label>
                            <Select
                                className='w-100'
                                placeholder={newRoleId ? "Select Parent Role" : "Select New Role first"}
                                value={parentRoleId || undefined}
                                onChange={handleParentRoleChange}
                                disabled={!newRoleId || !parentRoleOptions.length}
                                loading={roleParentLoading}
                                showSearch
                                optionFilterProp="label"
                                options={parentRoleOptions.map(r => ({
                                    value: r._id,
                                    label: `${r.name} (${r.code})`
                                }))}
                            />
                            {newRoleId && !parentRoleOptions.length && !roleParentLoading && (
                                <small className='text-danger'>No eligible parent role (already at top).</small>
                            )}
                        </div>

                        <div className='col-md-12 form-group'>
                            <label>Parent User <span className='text-danger'>*</span></label>
                            <Select
                                className='w-100'
                                placeholder={parentRoleId ? "Select Parent User" : "Select Parent Role first"}
                                value={parentUserId || undefined}
                                onChange={(v) => setParentUserId(v)}
                                disabled={!parentRoleId}
                                loading={roleParentLoading}
                                showSearch
                                optionFilterProp="label"
                                options={parentUserOptions.map(u => ({
                                    value: u._id,
                                    label: `${u.name} (${u.username})`
                                }))}
                            />
                        </div>
                    </div>
                </Modal>}

            {/* --------- User Permission Modal (shared component) --------- */}
            <UserPermissionModal
                open={isModalUserPermission}
                user={permissionUser}
                onClose={handleClosePermissionModal}
                theme={{ primary: '#C9262C' }}
            />
        </div>
    );
}

export default App;